import { render, staticRenderFns } from "./FastProductArrival.vue?vue&type=template&id=20ea7fd2&scoped=true&"
import script from "./FastProductArrival.vue?vue&type=script&lang=js&"
export * from "./FastProductArrival.vue?vue&type=script&lang=js&"
import style0 from "./FastProductArrival.vue?vue&type=style&index=0&id=20ea7fd2&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20ea7fd2",
  null
  
)

export default component.exports